<template>
	<div class="absolute w-full h-full top-0 pointer-events-none">
		<div v-for="x in particles" class="particles" :key="x.id" :style="{ width: `${x.width}px`, top: `${x.top}px`, left: `${x.left}px`, backgroundImage: `${x.bgImg}`, filter: `blur(${x.blur}px)` }" :ref="`particle${x.id}El`" :id="`particle${x.id}El`">
			<!-- <img alt="" src="images/ball-small-gold.png" /> -->
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
gsap.registerPlugin(MotionPathPlugin);

var stats = null;
export default {
	name: "particle-1",
	props: {
		configs: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			particles: [],
			running: false,
			particleCount: 0,
			particleTimeout: [],
			context: null,
		};
	},
	methods: {
		start() {
			if (this.running == true) return;
			this.running = true;
			this.initCreateParticle();
		},
		stop() {
			console.log("stop particle");
			this.running = false;
			clearTimeout(this.particleTimeout);
			this.context.revert();
			this.particles = [];
		},
		initCreateParticle() {
			this.particleTimeout = setTimeout(() => {
				this.createParticle(this.particleCount);
				this.particleCount++;
				this.initCreateParticle();
			}, Math.floor(Math.random() * (this.configs.interval.max - this.configs.interval.min) + this.configs.interval.min));
		},
		// width, top, left, bgImg
		createParticle(id) {
			if (this.running == false) return;

			var randCell = Math.floor(Math.random() * this.configs.cellPos.length);

			// cell 0 always sticks, for page 3 only
			if (this.configs.stickRate && Math.random() <= this.configs.stickRate) {
				randCell = 0;
			}

			const cellEl = this.configs.cellPos[randCell];
			const particleSize = Math.floor(Math.random() * (this.configs.size.max - this.configs.size.min) + this.configs.size.min);

			const radius = cellEl.width / 2;
			const centerX = cellEl.left + radius;
			const centerY = cellEl.top + radius;
			const angle = Math.random() * Math.PI * 2; // Random angle in radians

			const x = centerX + radius * Math.cos(angle) - particleSize / 2; // x-coordinate on circumference
			const y = centerY + radius * Math.sin(angle) - particleSize / 2; // y-coordinate on circumference

			if (this.configs.type == "normal") {
				var color = Math.random() <= this.configs.black ? "black" : "gold";
				var bgImg = color == "black" ? "url(images/ball-small-black.png)" : "url(images/ball-small-gold.png)";

				var stick = true;
				if (this.configs.stickToCell && !this.configs.stickToCell.includes(randCell)) {
					stick = false;
				}

				// var absorb = true;
				// if (color == "black") {
				// 	if (Math.random() > this.configs.blackAbsorbRate) {
				// 		absorb = false;
				// 	}
				// }
			} else {
				var bgImg = "url(images/pollutant-stress.png)";
				var stick = false;
				// var absorb = false;
			}

			// this.particles.push({ id: id, color: color, bgImg: bgImg, width: particleSize, left: x, top: y, stick: stick, absorb: absorb, blur: 0, cell: randCell });
			this.particles.push({ id: id, color: color, bgImg: bgImg, width: particleSize, left: x, top: y, stick: stick, blur: 0, cell: randCell });
			this.$nextTick(() => {
				// console.log(this.$refs[`particle${id}El`][0].getBoundingClientRect().top);
				gsap.set(this.$refs[`particle${id}El`], { y: -(this.$refs[`particle${id}El`][0].getBoundingClientRect().top / ratioToOriginal) - 50 });
				this.context.add(() => {
					this.moveParticle(id);
				});
			});
		},
		moveParticle(id) {
			if (this.running == false) return;

			var elementData = this.particles.find((item) => item.id == id);
			var element = this.$refs[`particle${id}El`];

			// console.log(elementData.stick);
			// return;

			if (elementData.stick == true) {
				var xCurve1 = Math.floor(Math.random() * 300 - 150); //-200 to 200
				var xCurve2 = Math.floor(Math.random() * 300 - 150); //-200 to 200

				const currentY = gsap.getProperty(element[0], "y");
				var yCurve1 = Math.floor((currentY / 3) * 2);
				var yCurve2 = Math.floor((currentY / 3) * 1);

				// console.log(gsap.getProperty(element[0], "y"), yCurve1, yCurve2);

				gsap.to(element, {
					duration: 6,
					force3D: true,
					motionPath: {
						path: [
							{ x: xCurve1, y: yCurve1 },
							{ x: xCurve2, y: yCurve2 },
							{ x: 0, y: 0 },
						],
						curviness: 1.5,
					},
					// delay: 0,
					ease: "out", // Gently decelerates towards the end
					onComplete: (id) => {
						gsap.delayedCall(1, () => {
							this.leave(id);
						});
					},
					onCompleteParams: [id],
				});
			} else {
				var xCurve1 = Math.floor(Math.random() * 200 - 100); //-100 to 100
				var xCurve2 = Math.floor(Math.random() * 200 - 100); //-100 to 100
				var xCurve3 = Math.floor(Math.random() * 400 - 200); //-200 to 200

				const currentY = gsap.getProperty(element[0], "y");
				var yCurve1 = Math.floor((currentY / 3) * 2);
				var yCurve2 = Math.floor((currentY / 3) * 1);
				var yCurve3 = Math.floor(1500);

				gsap.to(element, {
					duration: 17,
					force3D: true,
					motionPath: {
						path: [
							{ x: xCurve1, y: yCurve1 },
							{ x: xCurve2, y: yCurve2 },
							{ x: 0, y: 0 },
							{ x: xCurve3, y: yCurve3 },
						],
						curviness: 1.5,
					},
					ease: "out", // Gently decelerates towards the end
					onComplete: (id) => {
						this.killParticle(id);
					},
					onCompleteParams: [id],
				});
			}
		},
		leave(id) {
			if (this.running == false) return;

			const elementData = this.particles.find((item) => item.id == id);
			const element = this.$refs[`particle${id}El`];

			var absorb = false;
			if (elementData.color && elementData.color == "black") {
				if (Math.random() < this.configs.blackAbsorbRate) {
					absorb = true;
				}
			}
			if (elementData.color && elementData.color == "gold") {
				if (Math.random() < this.configs.goldAbsorbRate) {
					absorb = true;
				}
			}

			if (absorb == true) {
				if (elementData.color == "gold") {
					// prettier-ignore
					gsap.to(element, { autoAlpha: 0, scale: 0.3, duration: 3, ease: "out", delay: 0.7, onComplete: (id) => {
						this.killParticle(id)
					},
					onCompleteParams: [id]});
				} else {
					this.$emit("shrinkCell", elementData.cell); //cell num and duration to tween
					// prettier-ignore
					gsap.to(elementData, { blur: 10, duration: 6, ease: "none", delay: 0.7, onComplete: () => {
						gsap.to(element, { autoAlpha: 0, duration: 4, onComplete: (id) => {
							this.killParticle(id);
						},
						onCompleteParams: [id]});
					}});
				}
			} else {
				var xCurve1 = Math.floor(Math.random() * 50 - 25); //-20 to 20
				var xCurve2 = Math.floor(Math.random() * 1000 - 500); //-200 to 200
				var yCurve2 = Math.floor(Math.random() * 200 + 1000); //1000 to 1200

				gsap.to(element, {
					motionPath: {
						path: [
							{ x: 0, y: 0 },
							{ x: xCurve1, y: -20 },
							{ x: xCurve1, y: 300 },
							{ x: xCurve2, y: yCurve2 },
						],
						force3D: true,
						curviness: 1.5,
					},
					duration: 6,
					ease: "none",
					onComplete: (id) => {
						this.killParticle(id);
					},
					onCompleteParams: [id],
				});
			}
		},
		killParticle(id) {
			const index = this.particles.findIndex((item) => item.id == id);
			this.particles.splice(index, 1);
		},
		killAllTweens() {
			this.context.revert();
			// const elements = Object.values(this.$refs).flat();
			// gsap.killTweensOf(elements); // Kill tweens for all elements at once
		},
	},
	mounted() {
		// this.start();
		// console.log(this.configs);
		this.context = gsap.context(() => {}, this.$el); // Scope to the component's root element
	},
};
</script>

<style scoped>
.particles {
	position: absolute;
	aspect-ratio: 1;
	border-radius: 100%;
	z-index: 30;
	background-size: contain;
	background-repeat: no-repeat;
	will-change: transform;
	overflow: visible;
}
</style>
